import { render } from "./EnvironmentWarning.vue?vue&type=template&id=ea66ca66"
import script from "./EnvironmentWarning.vue?vue&type=script&lang=js"
export * from "./EnvironmentWarning.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__